import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MovimientoCajaRutaIndex } from "../edit/index";
import { StatusCajaListFiltro } from "../list/listfiltro";
import { ConexionesCajas } from "../conexiones";
export class MovimientosCajaIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <kea.Title titulo="Movimientos de caja" />

                <MovimientoCajaRutaIndex />
                <hr />
                <kea.Tab 
                    items={[
                        { 
                            body: <StatusCajaListFiltro />,
                            iconClass: fa("list-ol"),
                            title: "Status de cajas",
                            quitar: true
                        }, {
                            body: <ConexionesCajas />,
                            title: "Relación de camiones",
                            iconClass: fa("truck"),
                            quitar: true
                        }
                    ]}
                />
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/container/index.tsx